var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-img',{staticStyle:{"cursor":"pointer"},attrs:{"max-width":"28","max-height":"28","alt":"Back","src":"https://suppystorage.blob.core.windows.net/valeur/wsa/icons/back.svg"},on:{"click":function($event){return _vm.$emit('onClick')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }